import { PublicClientApplication } from "@azure/msal-browser";
export class AuthService {
    msalInstance;
    account = null;
    clientId;
    constructor(msalInstance, clientId) {
        this.msalInstance = msalInstance;
        this.clientId = clientId;
    }
    static async create(authority, clientId) {
        const config = {
            auth: {
                clientId: clientId,
                authority: authority,
                redirectUri: window.location.origin,
            },
            cache: {
                cacheLocation: "localStorage",
                storeAuthStateInCookie: false,
            },
        };
        const msalInstance = new PublicClientApplication(config);
        await msalInstance.initialize();
        return new AuthService(msalInstance, clientId);
    }
    async handleRedirect() {
        try {
            const response = await this.msalInstance.handleRedirectPromise();
            if (response) {
                this.account = response.account;
                return response;
            }
            const accounts = this.msalInstance.getAllAccounts();
            if (accounts.length > 0) {
                this.account = accounts[0];
            }
            return null;
        }
        catch (error) {
            console.error("Redirect handling failed:", error);
            return null;
        }
    }
    async signIn() {
        try {
            await this.msalInstance.loginRedirect({
                scopes: [
                    "openid",
                    "profile",
                    `api://${this.clientId}/access_as_user`,
                    `api://${this.clientId}/advosys_api`
                ],
                state: window.location.pathname
            });
        }
        catch (error) {
            console.error("Redirect login failed:", error);
        }
    }
    async getAccessToken() {
        if (!this.account) {
            const accounts = this.msalInstance.getAllAccounts();
            if (accounts.length === 0)
                return null;
            this.account = accounts[0];
        }
        try {
            const response = await this.msalInstance.acquireTokenSilent({
                scopes: [
                    `api://${this.clientId}/access_as_user`,
                    `api://${this.clientId}/advosys_api`
                ],
                account: this.account,
            });
            return response;
        }
        catch (error) {
            console.warn("Silent token failed, falling back to redirect...");
            await this.msalInstance.acquireTokenRedirect({
                scopes: [
                    `api://${this.clientId}/access_as_user`,
                    `api://${this.clientId}/advosys_api`
                ],
            });
            return null;
        }
    }
    logout() {
        this.msalInstance.logoutRedirect();
    }
}
